module.exports = __webpack_public_path__ + "img/podplayer-icon-green.09548c63.png";